import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;

    const honeypotEl = e.currentTarget.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotEl && honeypotEl.value.trim()) {
      setStatus('success');
      setStatusMsg('订阅成功！感谢你的关注~');
      setEmail('');
      return;
    }

    setStatus('loading');
    try {
      const formData = new FormData(e.currentTarget);
      const res = await fetch('https://readdy.ai/api/form/d9sn3t94ne17ei0sdkb0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢你的关注~');
        setEmail('');
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } })?.meta?.message || (parsed as { message?: string })?.message || '';
        setStatus('error');
        setStatusMsg(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请稍后再试');
    }
  };

  return (
    <section id="newsletter" className="w-full px-4 md:px-6 py-14 md:py-20 bg-primary-500/5">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-3">订阅更新通知</h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
          订阅奶水动漫，第一时间获取最新哺乳育儿漫画更新。我们每周推送精选内容，绝无垃圾信息。
        </p>

        <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto">
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="antispam-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入你的邮箱地址"
            required
            className="flex-1 w-full sm:w-auto px-5 py-3 rounded-full border border-background-300/60 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-7 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap text-sm cursor-pointer disabled:opacity-60 w-full sm:w-auto"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status !== 'idle' && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-600' : 'text-red-500'}`}>
            {statusMsg}
          </p>
        )}
      </div>
    </section>
  );
}